import React from 'react';
import {observer} from "mobx-react-lite";
import {useRootStore} from "@stores/AppStateContext";

import {ItemModelType} from "../../../../stores/WorkspaceStore";

import {ArticleIcon} from "../../../components/icons/ArticleIcon";
import {Select} from '../../../components/form/Select/Select';
import {InfoIcon} from "../../../components/icons/InfoIcon";

import "./RelatedItemsSelect.css"

export interface RelatedItemsSelectProps {
    itemId: string | null
    setItemId: (selectedId: string | null) => void;
    hasError?: boolean;
    errorText?: string;
    placeholder: string
}

export const RelatedItemsSelect = observer((
    {
        itemId,
        setItemId,
        hasError,
        errorText,
        placeholder,
    }: RelatedItemsSelectProps
) => {
    const rootStore = useRootStore();
    const allItems: ItemModelType[] = Array.from(rootStore.view.workspace!.items.values());
    const visibleItems = allItems
        .filter(item => !item.trashed && !item.archived && !item.isCluster)
        .map(item => ({
            value: item.id,
            label: item.name || item.getNamePlaceholder(rootStore.currentLocale),
            Icon: ArticleIcon,
        }));

    return (
        <>
            <Select
                className="RelatedItemsSelect"
                selectedValue={itemId}
                options={visibleItems}
                onChange={setItemId}
                placeholder={placeholder}
                size="extraLarge"
                allowFilter={true}
                isFullWidth={true}
                allowEmpty={true}
                hasError={hasError}
                iconSize={24}
                style={'select2'}
                maxHeight={360}
                shouldForcePlace={true}
            />
            {
                hasError
                    ? (
                        <div className="RequiredItem--error label-large">
                            <InfoIcon className={"RequiredItem--errorIcon"} size={16}/>
                            {errorText}
                        </div>
                    )
                    : null
            }
        </>
    );
});
